// extracted by mini-css-extract-plugin
export var content = "_7b-3";
export var list = "_7b-4";
export var settingsContent = "_7b-7";
export var settingsPanel = "_7b-8";
export var state = "_7b-6";
export var triggerBadge = "_7b-2";
export var triggerButton = "_7b-1";
export var triggerShell = "_7b-0";
export var unreadDot = "_7b-5";